export default "__VITE_ASSET___c0IR1pq__"